module.exports = __webpack_public_path__ + "static/img/sauce.bc31d756.webp";